import type { ModulePage } from './types'

export const reports: ModulePage = {
  slug: 'reports',
  name: 'AI Report Writer',
  tagline: 'Suitability reports drafted in minutes, ready for your review and sign-off.',
  icon: 'document',
  colorClass: 'referral',
  pricingModules: ['reports_full'],
  featured: true,

  seo: {
    title: 'AI Suitability Report Writer',
    description:
      'Generate personalised first-draft suitability reports from your meeting notes and client data, ready for adviser review. Full report builder, AI generation, and compliance support.',
    keywords:
      'AI suitability reports, automated report writing IFA, financial adviser report software, COBS report templates',
  },

  hero: {
    eyebrow: 'AI Report Writer',
    title: 'Suitability reports,',
    titleAccent: 'written in minutes',
    subtitle:
      'Turn meeting notes and client data into a personalised first-draft report: drafted by AI, shaped by your templates, ready for your review and sign-off.',
  },

  useCases: [
    {
      icon: 'document',
      title: 'Suitability & advice reports',
      body: 'Generate first-draft suitability reports straight from the meeting, then review and sign off rather than write from scratch.',
    },
    {
      icon: 'chart',
      title: 'Annual review reports',
      body: 'Pull the year’s changes, performance and recommendations into a clean, client-ready document automatically.',
    },
  ],

  benefits: [
    {
      icon: 'document',
      title: 'Full report builder',
      body: 'Build, brand and reuse templates for every advice scenario: pensions, protection, investments and more.',
    },
    {
      icon: 'sparkle',
      title: 'AI generation',
      body: 'Personalised, well-structured prose drafted from your data, in your firm’s house style.',
    },
    {
      icon: 'shield',
      title: 'Compliance support',
      body: 'Built-in checklists and prompts help you check each report against your firm’s templates and policies before sign-off.',
    },
    {
      icon: 'bolt',
      title: 'Consistency at scale',
      body: 'Every adviser produces the same high-quality, on-brand report, without the copy-paste.',
    },
  ],

  stats: [
    { value: 'Minutes', label: 'per report, not hours' },
    { value: '100/mo', label: 'AI reports on higher tiers' },
  ],

  testimonial: {
    quote:
      'WealthSpace offers flexibility and keeps advisers in control. Support is there if you need it, but you can adapt firm-specific elements like report templates at your own pace.',
    author: 'Dan Wiltshire',
    role: 'Independent Financial Planner',
    company: 'Wiltshire Wealth',
  },

  cta: {
    title: 'Get your evenings',
    titleAccent: 'back',
    subtitle:
      'Generate a first-draft suitability report from a real meeting and see the difference for yourself.',
    note: 'Start free. No credit card required.',
  },
}
